/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-25 14:02:50
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-25 16:45:52
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\snippets\form\js\pew-tooltip.js
 * @Description: 付费延保 - tooltip 交互
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */
export function initPEWTooltip() {
  const tooltips = document.querySelectorAll('.pew-tooltip');
  let hideTimeout;
  tooltips.forEach(tooltip => {
    const icon = tooltip.querySelector('.icon-info');
    const tooltipBox = tooltip.querySelector('.tooltip-box');

    const showTooltip = () => {
      clearTimeout(hideTimeout);
      tooltipBox.style.display = 'block';
    };

    const hideTooltip = () => {
      hideTimeout = setTimeout(() => {
        tooltipBox.style.display = 'none';
      }, 150);
    };

    if (window.innerWidth > 1023) {
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      tooltipBox.addEventListener('mouseenter', () => clearTimeout(hideTimeout));
      tooltipBox.addEventListener('mouseleave', hideTooltip);
    }
  });

};